var render = function render(){var _vm=this,_c=_vm._self._c;return _c('jtooltip',{staticClass:"advicePopup",attrs:{"popoverClass":['advicePopover'],"trigger":_vm.manual ? 'manual' : 'hover',"title":_vm.tooltipTitle,"content":_vm.tooltipText}},[_c('span',{staticClass:"adviceText",class:{
      manual: _vm.manual,
      normalLineHeight: _vm.normalLineHeight,
    },attrs:{"slot":"target"},slot:"target"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }